module.exports = __webpack_public_path__ + "assets/e9dc1d52787960446d7c4779888da0ed.svg";